import { RadioGroup } from "@headlessui/react";

import { MobileAboCard } from "@/components/Onboarding/Steps/RateSelection/MobileAboCard";
import { TransformedProduct } from "@/utils/tariffUtils";

export const MobileAboForm = ({
  value,
  setValue,
  mobileAbos,
}: {
  value: string | undefined;
  setValue: (value: string) => void;
  mobileAbos: TransformedProduct[];
  showCustomRateTab: () => void;
  isCustomRateTabLinkDisabled?: boolean;
  currentTariffIsFlatMobile?: boolean;
}) => {
  return (
    <div className="mt-8 flex flex-col">
      <RadioGroup value={value ?? ""} onChange={setValue}>
        <div className="-mx-10 flex flex-wrap justify-center gap-6">
          {mobileAbos.map((product) => (
            <MobileAboCard
              key={product.id}
              value={value}
              product={product}
              tribeDiscount={0}
              disabled={false} // Remove precharged product logic for partner app
            />
          ))}
        </div>
      </RadioGroup>
    </div>
  );
};
